import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { CardStyled } from './Card.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface CardPropsType {
    children: React.ReactNode;
    haveBorder?: boolean;
}

export const Card = observer('Card', ({ children, haveBorder = false }: CardPropsType) => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    return (
        <CardStyled
            haveBorder={haveBorder}
            variant={configState.componentVariants.accountSectionVariant}
        >
            {children}
        </CardStyled>
    );
});
